var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("span", { staticClass: "print-documents" }, [
    !_vm.mailIsLoaded
      ? _c(
          "div",
          {
            staticClass:
              "loading-content-container d-flex justify-content-center",
          },
          [_c("csp-loading-indicator")],
          1
        )
      : _c(
          "div",
          { staticClass: "info-card editMode" },
          [
            _c(
              "b-row",
              [
                _c("csp-form-group-input", {
                  staticClass: "col-6 info-card-element",
                  attrs: {
                    form: _vm.mailForm,
                    "override-label": "Absender Name",
                    property: "fromName",
                    required: true,
                    type: "text",
                  },
                }),
                _vm._v(" "),
                _c("csp-form-group-input", {
                  staticClass: "col-6 info-card-element",
                  attrs: {
                    autocomplete: "email",
                    form: _vm.mailForm,
                    "override-label": "Absender Email",
                    property: "fromMail",
                    required: true,
                    type: "email",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("csp-form-group-input", {
                  staticClass: "col-6 info-card-element",
                  attrs: {
                    form: _vm.mailForm,
                    "override-label": "Empfänger Name",
                    property: "toName",
                    type: "text",
                  },
                }),
                _vm._v(" "),
                _c("csp-form-group-input", {
                  staticClass: "col-6 info-card-element",
                  attrs: {
                    autocomplete: "email",
                    form: _vm.mailForm,
                    "override-label": "Empfänger Email",
                    property: "toMail",
                    required: true,
                    type: "email",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.hasInternalCopy
              ? [
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-form-group-select-searchable", {
                        staticClass: "col-6 info-card-element",
                        attrs: {
                          form: _vm.mailForm,
                          options: _vm.internalCopyOptions,
                          "override-label": "Interne Kopie an",
                          property: "internalCopy",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.hasDateReminder
              ? [
                  _c("hr"),
                  _vm._v(" "),
                  _c(
                    "b-row",
                    [
                      _c("csp-form-group-datepicker", {
                        staticClass: "col-6 info-card-element",
                        attrs: {
                          form: _vm.mailForm,
                          "max-date": null,
                          "min-date": _vm.dateNowAsString(),
                          "override-label": "Datum Wiedervorlage/Frist Vermerk",
                          property: "dateReminder",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("b-row", [
              _c(
                "div",
                { staticClass: "form-group col-12 info-card-element" },
                [
                  _c("additional-mail-recipients", {
                    attrs: { form: _vm.additionalMailRecipientsForm },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _c("csp-form-group-input", {
                  staticClass: "col-12 info-card-element",
                  attrs: {
                    form: _vm.mailForm,
                    "override-label": "Betreff",
                    property: "subject",
                    required: true,
                    type: "text",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("b-row", [
              _c(
                "div",
                { staticClass: "form-group col-12 info-card-element" },
                [
                  _c("csp-form-group-ckeditor", {
                    attrs: {
                      form: _vm.mailForm,
                      "override-label": "Nachricht",
                      property: "mailMessage",
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.recordId ? _c("hr") : _vm._e(),
            _vm._v(" "),
            _vm.recordId
              ? _c("b-row", [
                  _c(
                    "div",
                    { staticClass: "form-group col-12 info-card-element" },
                    [
                      _c("csp-hide-for-group", {
                        attrs: {
                          form: _vm.hideForGroupForm,
                          "override-label": "Sichtbarkeit",
                          property: "hide",
                          "record-id": _vm.recordId,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("hr"),
            _vm._v(" "),
            _c("b-row", [
              _c(
                "div",
                { staticClass: "form-group col-12 info-card-element" },
                [
                  _c("common-attachments", {
                    attrs: {
                      attachments: _vm.commonAttachments,
                      form: _vm.commonAttachmentsForm,
                      path: _vm.path,
                    },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _vm.staticAttachments.length > 0
              ? _c("b-row", [
                  _c(
                    "div",
                    { staticClass: "form-group col-12 info-card-element" },
                    [
                      _c("static-attachments", {
                        attrs: {
                          attachments: _vm.staticAttachments,
                          "default-check-attachments":
                            _vm.defaultCheckStaticAttachments,
                          form: _vm.staticAttachmentsForm,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _vm.documentAttachments.length > 1
              ? _c("b-row", [
                  _c(
                    "div",
                    { staticClass: "form-group col-12 info-card-element" },
                    [
                      _c("document-attachments", {
                        attrs: {
                          attachments: _vm.documentAttachments,
                          form: _vm.documentAttachmentsForm,
                        },
                      }),
                    ],
                    1
                  ),
                ])
              : _vm._e(),
            _vm._v(" "),
            _c("div", { staticClass: "form-group text-right" }, [
              _c(
                "button",
                {
                  staticClass: "btn btn-secondary",
                  on: {
                    click: function ($event) {
                      return _vm.$emit("cancel-mail")
                    },
                  },
                },
                [_vm._v("\n                Abbrechen\n            ")]
              ),
              _vm._v(" "),
              _c(
                "button",
                { staticClass: "btn btn-primary", on: { click: _vm.sendMail } },
                [
                  _vm.isUpdating
                    ? _c("span", {
                        staticClass: "spinner-border spinner-border-sm",
                        attrs: { "aria-hidden": "true", role: "status" },
                      })
                    : _vm._e(),
                  _vm._v("\n                Senden\n            "),
                ]
              ),
            ]),
          ],
          2
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }